import { Link } from "react-router-dom";
import type { Article } from "@/lib/articles";
import { formatShortDate } from "@/lib/articles";

export default function RelatedArticles({ articles }: { articles: Article[] }) {
  if (!articles.length) return null;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
        <i className="ri-links-line w-5 h-5 flex items-center justify-center text-primary-500"></i>
        相关推荐
      </h3>
      <ul className="mt-4 space-y-4">
        {articles.map((article) => (
          <li key={article.id}>
            <Link to={`/detail/${article.id}`} className="group flex gap-3">
              <div className="h-16 w-20 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={article.cover}
                  alt={article.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0">
                <h4 className="line-clamp-2 text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h4>
                <p className="mt-1 text-xs text-foreground-500">
                  {formatShortDate(article.publishedAt)}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}